import { computed, Injectable, signal } from '@angular/core';
import type { ChartType, ChartOptions } from 'chart.js';
import { VerticalBarsKpi } from '../../../types';
import { chartDefaults } from '../defaults';

@Injectable()
export class ChartService {
  public readonly barChartType: ChartType = 'bar';

  public readonly barChartPlugins = chartDefaults.plugins();

  public readonly barChartOptions: ChartOptions<'bar'> =
    chartDefaults.options();

  public readonly data$ = signal<VerticalBarsKpi>(null!);

  public readonly recommendedHeight$ = computed(() => 370);

  public readonly barChartData$ = computed(() => {
    const yAxisLabel = this.data$()?.yAxisLabel?.trim();
    const barChartData = chartDefaults.data();

    this.barChartOptions.scales.y.title = {
      display: Boolean(yAxisLabel),
      text: yAxisLabel,
    };

    const blueColor = 'rgba(54, 162, 235, 0.8)';
    this.data$()?.value.forEach((item) => {
      barChartData.labels.push(item.label);
      barChartData.datasets[0].data.push(item.value);
    });

    barChartData.datasets[0].backgroundColor = blueColor;
    barChartData.datasets[0].borderColor = 'transparent';
    barChartData.datasets[0].borderWidth = 0;

    return barChartData;
  });

  public chartClicked(event: any): void {
    if (!event.active?.length || event.active?.[0]?.index === undefined) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const clickedIndex = event.active[0]?.index;
    const link = this.data$()?.value[clickedIndex]?.link;
  }
}
